import { createContext, useContext } from 'react'

export const EditCropContext = createContext(null)

/**
 * Returns null gracefully when used outside EditCropContextProvider.
 * Timeline components guard with optional chaining (ctx?.editingCropId).
 */
export const useEditCropContext = () => useContext(EditCropContext)
